module.exports = __webpack_public_path__ + "static/media/NotoSansCJKjp-Regular.26322e29.svg";